import TransactionItem from "./TransactionItem";

export default function TransactionList({ transactions = [] }) {
  return (
    <section
      className="rounded-2xl border border-black/5 dark:border-white/10
                 bg-white dark:bg-slate-900 shadow-sm p-5"
    >
      <div className="flex items-center justify-between">
        <h3 className="text-base font-semibold text-slate-900 dark:text-white">
          Transactions récentes
        </h3>
        <button className="text-sm text-blue-600 dark:text-blue-400 hover:underline">
          Voir tout
        </button>
      </div>

      <div className="mt-4">
        {transactions.length > 0 ? (
          <div className="space-y-2">
            {transactions.map((txn, index) => (
              <TransactionItem
                key={txn.id || index}
                name={txn.name}
                date={txn.date}
                amount={txn.amount}
                status={txn.status}
              />
            ))}
          </div>
        ) : (
          <div className="rounded-2xl border border-dashed border-black/10 dark:border-white/10 p-6 text-center">
            <p className="text-sm text-slate-500 dark:text-slate-400">
              Aucune transaction récente.
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
